import { getDayDelta } from "@utils/datetime";
import getStore from "@utils/redux/store";

export function computeTrialDuration(
  growthProgramStartDateISO: string,
  growthTrialEndDateISO: string
) {
  return getDayDelta(
    new Date(growthProgramStartDateISO),
    new Date(growthTrialEndDateISO)
  );
}

export function getTrialDurationFromUserData() {
  const { growthTrialEndDateISO, growthProgramStartDateISO } =
    getStore().getState().userData;
  return computeTrialDuration(growthProgramStartDateISO, growthTrialEndDateISO);
}
